import { FeedbackApiService } from "./FeedbackApiService";
import { RestApiClient } from "../../../../Scripts/inpulse/RestApiClient";

declare interface Window {
    location: Location;
}

declare interface Location {
    origin: string;
}


/*Service to handle feedback related stuff*/
export class DefaultFeedbackService {

    private _service: FeedbackApiService;
    private _unreadMessages = -1;
    private _unreadMessagesBadge: HTMLElement;
    private _errorBadge: HTMLElement;

    private _unreadMessagesBadges: HTMLCollectionOf<Element>;
    private _errorBadges: HTMLCollectionOf<Element>;

    ////Tämän voisi muuttaa niin, että elementit annettaisiin metodille ShowMyUnreadMessagesCount konstruktorin sijaan, jotta luokka olisi monikäyttöisempi
    constructor(apiUrl: string, unreadMessagesBadge: HTMLElement, errorBadge: HTMLElement, unreadMessagesBadges: HTMLCollectionOf<Element>, errorBadges: HTMLCollectionOf<Element> )
    {
        if (apiUrl == null) {
            apiUrl = window.location.origin + "api/feedback";//https://domain/api/feedback
        }
        this._service = new FeedbackApiService(new RestApiClient(apiUrl));//api/feedback     
        this._unreadMessagesBadge = unreadMessagesBadge;
        this._errorBadge = errorBadge;

        this._unreadMessagesBadges = unreadMessagesBadges;
        this._errorBadges = errorBadges;

        if (this._errorBadge == null)
        {
            console.warn("Error badge not defined!");
        }
        if (this._unreadMessagesBadge == null)
        {
            console.warn("Unread message badge not defined!");
        }
    }

    GetMyUnreadMessages(): Promise<number> {
        return this._service.MyNewMessagesCount();
    }

    ////Tämän voisi muuttaa niin, että elementit annettaisiin metodille ShowMyUnreadMessagesCount konstruktorin sijaan, jotta luokka olisi monikäyttöisempi
    ShowMyUnreadMessagesCount(): void {
        this.GetMyUnreadMessages().then(result => {
            //TODO logic to add messages count to post
            console.log(result);
            this._unreadMessages = result;
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            if (this._unreadMessages === -1)
            {
                //error
                this.hideBadges(false);

                this.showBadges(true, "?");        
            }
            else if (this._unreadMessages === 0)
            {
                this.NoNewMessages();
            }
            else
            {
                //new messages
                this.hideBadges(true);

                this.showBadges(false, this._unreadMessages.toString());   
            }
        });
    }

    private showBadges(error: boolean, msg: string): void
    {
        if (error)
        {
            this.showBadgesInternal(this._errorBadge, this._errorBadges, msg);
        }
        else
        {
            this.showBadgesInternal(this._unreadMessagesBadge, this._unreadMessagesBadges, msg);
        }
    }

    private showBadgesInternal(badge: HTMLElement, badges: HTMLCollectionOf<Element>, msg: string) {
        if (badges != null) {
            Array.from(badges).forEach(function (element) {
                element.innerHTML = msg;
                element.classList.add("active");
            });
        }
        else {
            badge.innerHTML = msg;
            badge.classList.add("active");
        }
    }

    private NoNewMessages(): void
    {
        //no new messages
        if (this._unreadMessagesBadges != null) {
            Array.from(this._unreadMessagesBadges).forEach(function (element) {
                element.classList.remove("active");
            });
        }
        else
        {
            this._unreadMessagesBadge.classList.remove("active");
        }

        if (this._errorBadges != null) {
            Array.from(this._errorBadges).forEach(function (element) {
                element.classList.remove("active");
            });
        }
        else
        {
            this._errorBadge.classList.remove("active");
        }
    }

    private hideBadges(error: boolean): void
    {
        if (error)
        {
            this.hideInternal(this._errorBadge, this._errorBadges);
        }
        else
        {
            this.hideInternal(this._unreadMessagesBadge, this._unreadMessagesBadges);
        }
    }

    private hideInternal(badge: HTMLElement, badges: HTMLCollectionOf<Element>)
    {
        if (badges != null)
        {
            Array.from(badges).forEach(function (element) {
                element.classList.remove("active");
            });
        }
        else
        {
            badge.classList.remove("active");
        }
    }
}